import { buildInfoPages, COLOFON_PAGE_IDS } from "@plaatplan/i18n";

export { buildInfoPages, COLOFON_PAGE_IDS };

/** @deprecated Use COLOFON_PAGE_IDS */
export const COLOFON_LINKS = COLOFON_PAGE_IDS.map((pageId) => ({ pageId }));
